var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.52 118.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.08,76.68l-17.44,17.44H0l17.41-17.44h24.67Zm-22.78,4.54h0s0,0,0,0l-8.36,8.36h11.83l8.38-8.37h-11.84Z",
    fill: "#f9a51a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.07,76.68v24.67s-17.43,17.42-17.43,17.42v-24.65s17.43-17.43,17.43-17.43Zm-12.88,31.08l8.31-8.31v-11.77s-8.31,8.33-8.31,8.33v11.75Z",
    fill: "#fd0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.08,76.67h-24.67S0,59.25,0,59.25h24.63s17.45,17.43,17.45,17.43Zm-19.32-12.88h0s-11.75,0-11.75,0l8.31,8.3h11.77s-8.32-8.31-8.32-8.31Z",
    fill: "#8bc53f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.76,42.13s-11.06-6.94-11.27-7.08v-2.92c0-.31-.25-.56-.56-.56h-1.72v-5.15c0-.27-.22-.5-.5-.5h-1.42v-3.13c-.07-12.56-10.34-22.78-22.9-22.78s-22.29,9.7-22.86,21.8h-.03v25.66l-12.86-12.86-.02,24.64,17.46,17.44v-15.72h0V22.88c0-10.09,8.22-18.3,18.32-18.3s18.3,8.21,18.32,18.29v3.05h-1.45c-.27,0-.5.22-.5.5v5.15h-1.67c-.31,0-.56.25-.56.56v2.92c-.21.14-11.27,7.09-11.27,7.09,0,0-1.27.66,0,1.15,0,0,1.13.41,13.32.78h0c.57,2.27,1.81,5.15,4.43,5.15s3.86-2.88,4.43-5.15c12.19-.37,13.32-.78,13.32-.78,1.27-.49,0-1.15,0-1.15Zm-61.24,23.61l-8.3-8.38v-11.83l8.3,8.32v11.88Z",
    fill: "#00abcc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.99,76.87h-1.15l-4.17-7.67-.04,7.55h-2.95l.43-15.01h1.48l5.89,10.33,5.75-10.33h1.48l.43,15.01h-2.97l-.06-7.67-4.13,7.8Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.42,76.74h-3.24l-1.28-2.89h-5.94l-1.26,2.89h-3.18l7.01-15.07h.86l.06.13,6.96,14.94Zm-9.35-5.38h3.73l-1.87-4.22-1.87,4.22Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.32,76.74h-3v-14.95h3v14.95Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.62,76.85h-1l-8.79-8.78v8.68h-3v-15.03h1.12l8.66,9.02v-8.93h3v15.05Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.56,76.99c-1.61,0-3.38-.52-4.86-1.42l-.16-.1,1.05-2.75.23.16c1.19.8,2.58,1.26,3.82,1.26,1.38,0,2.27-.61,2.27-1.55,0-.83-.43-1.35-3.01-2.31-2.73-.99-3.94-2.33-3.94-4.31,0-2.2,1.75-4.43,5.09-4.43,1.43,0,3.04.4,4.11,1.02l.16.09-.98,2.69-.23-.13c-.81-.46-2.06-.94-3.13-.94-1.26,0-2.01.61-2.01,1.63,0,.79.7,1.32,2.68,2.04,3.11,1.21,4.31,2.51,4.31,4.64,0,2.71-2.08,4.39-5.42,4.39Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.44,76.74h-3.03v-12.15h-4.85v-2.8h12.64v2.8h-4.77v12.15Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.17,76.83c-2.42,0-3.22-1.42-3.93-2.68-.37-.66-.72-1.28-1.28-1.62-.23.02-.46.02-.71.02h-1.37v4.21h-3v-14.95h4.86c3.77,0,6.02,2.01,6.02,5.38,0,1.61-.79,3.62-2.55,4.63.26.26.47.55.68.83.54.73,1.01,1.35,2.08,1.35h.8v2.67l-.17.04s-.57.13-1.43.13Zm-7.29-7h1.67c1.99,0,3-.89,3-2.65s-.98-2.58-3-2.58h-1.67v5.23Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.97,76.74h-9.87v-14.95h9.87v2.8h-6.87v3.62h6.23v2.71h-6.23v3.02h6.87v2.8Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.78,76.74h-9.87v-14.95h9.87v2.8h-6.87v3.62h6.23v2.71h-6.23v3.02h6.87v2.8Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.75,76.74h-3.02v-12.15h-4.85v-2.8h12.64v2.8h-4.77v12.15Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.87,99.74h-3.24l-1.28-2.89h-5.94l-1.26,2.89h-3.18l7.01-15.07h.86l7.02,15.07Zm-9.35-5.38h3.73l-1.87-4.22-1.87,4.22Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.07,99.87h-1.15l-4.17-7.67-.04,7.55h-2.95l.43-15.01h1.48l5.89,10.33,5.75-10.33h1.48l.43,15.01h-2.97l-.06-7.67-4.13,7.8Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.4,99.74h-9.87v-14.95h9.87v2.8h-6.87v3.62h6.23v2.71h-6.23v3.02h6.87v2.8Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.93,99.83c-2.42,0-3.23-1.43-3.93-2.68-.37-.66-.72-1.29-1.28-1.62-.23.02-.46.02-.71.02h-1.37v4.21h-3v-14.95h4.86c3.77,0,6.02,2.01,6.02,5.38,0,1.61-.79,3.62-2.55,4.63.26.26.47.55.68.83.54.72,1.01,1.35,2.08,1.35h.8v2.67l-.17.04s-.57.13-1.43.13Zm-7.29-7h1.68c1.99,0,3-.89,3-2.65s-.98-2.58-3-2.58h-1.68v5.23Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.27,99.74h-3v-14.95h3v14.95Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.74,99.99c-4.94,0-8.39-3.18-8.39-7.73,0-4.25,3.61-7.71,8.04-7.71,3.2,0,5.15,1.16,5.23,1.21l.16.1-1.05,2.58-.21-.11s-1.9-.93-3.7-.93c-3.15,0-5.27,1.97-5.27,4.89s2.11,4.83,5.02,4.83c2.37,0,4.08-.95,4.1-.96l.23-.13.93,2.6-.15.1c-.08.05-1.97,1.25-4.95,1.25Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.82,99.74h-3.24l-1.28-2.89h-5.94l-1.26,2.89h-3.18l7.01-15.07h.86l.06.13,6.96,14.94Zm-9.35-5.38h3.73l-1.87-4.22-1.87,4.22Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.86,86.59c0-1.06.83-1.91,1.86-1.91s1.87.85,1.87,1.91-.83,1.89-1.87,1.89-1.86-.85-1.86-1.89Zm3.3,0c0-.83-.63-1.52-1.44-1.52s-1.44.69-1.44,1.52.65,1.5,1.44,1.5,1.44-.69,1.44-1.5Zm-2.15-1.03h.6c.62,0,.89.26.89.62,0,.25-.15.49-.38.61l.52.8h-.53l-.37-.71h-.29v.71h-.44v-2.04Zm.44.98h.18c.25,0,.41-.12.41-.34,0-.16-.15-.27-.38-.27h-.2v.61Z",
    fill: "#231f20",
    strokeWidth: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e1f1c1f138aebaf75dd392c07d09270.svg";
export { ForwardRef as ReactComponent };